import { render } from "./ShowingBadges.vue?vue&type=template&id=4b4bb640&scoped=true"
import script from "./ShowingBadges.vue?vue&type=script&lang=js"
export * from "./ShowingBadges.vue?vue&type=script&lang=js"

import "./ShowingBadges.vue?vue&type=style&index=0&id=4b4bb640&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b4bb640"]])

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QChip});
